import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class InfoBubble extends React.Component {

  /* Lifecycle */

  constructor(props) {
    super(props);

    this.clickCloseHandler = this.clickCloseHandler.bind(this);
  }

  /* Handlers */

  clickCloseHandler() {
    if (this.props.onClickClose) {
      return this.props.onClickClose(this);
    }

    this.setState({ closed: true });

    return true;
  }

  getContent() {
    const content = this.props.content;
    if (content === null || typeof (content) === 'undefined') {
      return this.props.children;
    }
    return content;
  }

  /* Render */

  renderContentContainerAttributes() {
    return null;
  }

  renderContentContainer() {
    return (
      <div className="info-bubble__content" {...this.renderContentContainerAttributes()}>
        {this.renderContent()}
      </div>
    );
  }

  renderContentLine(line, index) {
    const key = `info-bubble-line-${index}`;
    const content = line || '';
    let style = null;
    if (!line) {
      // Fake empty line by giving the div a height
      style = {
        minHeight: '10px',
      };
    }
    return (
      <div key={key} style={style}>
        {content}
      </div>
    );
  }

  renderContent() {
    if (this.props.onRenderContent) {
      return this.props.onRenderContent(this);
    }
    let content = this.getContent();
    if (typeof (content) === 'string' && (content.includes('\n') || content.includes('\r'))) {
      content = content.replace(/(\r\n|\r|\n)/g, '\n');
      const lines = content.split('\n');
      const items = lines.map(this.renderContentLine);

      return items;
    }
    return this.getContent();
  }

  renderOptions() {
    if (this.props.onRenderOptions) {
      return this.props.onRenderOptions(this);
    }
    return null;
  }

  createOptionEventHandler(option, eventType) {
    let handler = null;
    const { onClickOption } = this.props;
    if (option && eventType === 'click' && onClickOption) {
      handler = () => {
        return onClickOption(option);
      };
    }
    return handler;
  }

  renderOptionButton(optionClassName, clickArgs = null) {
    const className = `info-bubble__option-button ${optionClassName}`;
    const clickHandler = this.createOptionEventHandler(clickArgs, 'click');
    const pressHandler = this.createOptionEventHandler(clickArgs, 'press');
    const releaseHandler = this.createOptionEventHandler(clickArgs, 'release');

    return (<button
      className={className}

      onClick={clickHandler}

      onMouseDown={pressHandler}
      onTouchStart={pressHandler}

      onMouseUp={releaseHandler}
      onTouchEnd={releaseHandler}

      type="button"
    />);
  }

  renderCloseButton() {
    if (this.onRenderCloseButton) {
      return this.onRenderCloseButton(this);
    }
    if (!this.props.closable) {
      return null;
    }
    const clickHandler = this.clickCloseHandler;

    return <button onClick={clickHandler} className="info-bubble__close-button icon-close" type="button" />;
  }

  isClosed() {
    if (this.props.onClickClose) {
      return this.props.closed;
    }
    return this.state ? !!this.state.closed : false;
  }

  getClassName() {
    return 'info-bubble';
  }

  render() {
    let style = null;
    const { x, y } = this.props;
    const closed = this.isClosed();

    if (!!x || !!y) {
      style = {};
      if (typeof (x) === 'number') {
        style.left = `${Math.round(x)}px`;
      }
      if (typeof (y) === 'number') {
        style.top = `${Math.round(y)}px`;
      }
    }

    const className = classnames(
      this.getClassName(),
      { closed },
    );

    const options = this.renderOptions();
    let optionsContainer = null;
    if (options) {
      optionsContainer = (
        <div className="info-bubble__option-container">
          {options}
        </div>
      );
    }

    return (
      <div style={style} className={className}>
        <div className="info-bubble__component">
          {this.renderCloseButton()}
          {this.renderContentContainer()}
          {optionsContainer}
        </div>
      </div>
    );
  }
}

InfoBubble.defaultProps = {
  closable: true,
};

InfoBubble.propTypes = {
  children: PropTypes.any,
  x: PropTypes.number,
  y: PropTypes.number,

  closable: PropTypes.bool,

  closed: PropTypes.bool,
  content: PropTypes.any, // string or react component
  onRenderContent: PropTypes.func, // Override render method for content
  onRenderOptions: PropTypes.func, // Override render method for options

  onClickClose: PropTypes.func,
  onClickOption: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/components/info-bubble/index.jsx